import UnavailableMethodException from '@naturehouse/nh-essentials/lib/exceptions/UnavailableMethodException';
import type HttpError from '@naturehouse/nh-essentials/lib/requests/HttpError';
import CollectionBase from '../../../../common/CollectionBase';
import type { TranslatableCollectionData } from './TranslatableContent';

export default class NatureDescriptionCollection extends CollectionBase<TranslatableCollectionData> {
    static #instance: NatureDescriptionCollection | null = null;

    public static getInstance(): NatureDescriptionCollection {
        if (this.#instance === null) {
            this.#instance = new NatureDescriptionCollection();
        }

        return this.#instance;
    }

    private constructor() {
        super();
    }

    public async add(): Promise<void> {
        throw new UnavailableMethodException();
    }

    public async update(): Promise<void> {
        throw new UnavailableMethodException();
    }

    public async delete(): Promise<void> {
        throw new UnavailableMethodException();
    }

    protected endpoint(params: TranslatableCollectionData): string {
        return `/api/houses/${params.id}/descriptions/nature/${params.language}`;
    }

    protected onError(error: HttpError<AjaxResponseError>): void {
        throw new Error(error.body?.message);
    }
}
